export const FETCH_SNIPPETS = "FETCH_SNIPPETS";
export const FETCH_SNIPPETS_SUCCESS = "FETCH_SNIPPETS_SUCCESS";
export const FETCH_SNIPPETS_FAILED = "FETCH_SNIPPETS_FAILED";
